import PropTypes from 'prop-types'

/**
 * Square button that accepts children and onClick handler with active? state.
 * Recommended children: single icon.
 * @param children
 * @param onClick
 * @param active
 * @returns {JSX.Element}
 * @component
 */
export const ChangeViewButton = ({ children, onClick, active }) => (
  <button
    type="button"
    className={`btn btn-sm rounded-8 py-1 px-2 me-1 ${
      active ? 'btn-secondary' : 'btn-outline-secondary'
    }`}
    style={{ fontSize: '1rem', height: '34px', width: '34px' }}
    aria-label="Change grid/list view"
    onClick={onClick}
  >
    {children}
  </button>
)

ChangeViewButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
}
